define('ice/ice.module',['angular', './ice.routes', './ice.controllers', './ice.services'], function(angular, routes, controllers) {
    'use strict';
    var mod = angular.module('com.cd.ice', ['ngRoute', 'ice.routes', 'ice.services']);
    return mod;
});
